/* eslint-disable react/no-danger */
import { Accordion, AccordionItem } from '@bwoty-web/ui-kit';
import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import './cruiseShippingCompanyFaqView.scss';

const CruiseShippingCompanyFaqView = ({ content, labels }) => {
  const { faq = [] } = content;
  return (
    <div className="gw-cruise-sc-faq-container">
      <h2 className="gw-cruise-sc-faq__header">
        {labels?.importantToKnowHeader}
      </h2>
      <Accordion oneAtATime>
        {faq.map((faqItem) => {
          return (
            <AccordionItem
              header={faqItem?.header}
              key={uniqid('gw-cruise-sc-faq__accordion-')}
            >
              {faqItem?.content && (
                <div
                  className="gw-cruise-sc-faq__accordion-content"
                  dangerouslySetInnerHTML={{ __html: faqItem?.content }}
                />
              )}
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
};

CruiseShippingCompanyFaqView.propTypes = {
  content: PropTypes.shape({
    faq: PropTypes.arrayOf(
      PropTypes.shape({
        header: PropTypes.string,
        content: PropTypes.string,
      }),
    ),
  }).isRequired,
  labels: PropTypes.shape({
    importantToKnowHeader: PropTypes.string,
  }).isRequired,
};

export default CruiseShippingCompanyFaqView;
